import React, { useState, useEffect, useRef, useCallback } from "react";
import { toast } from "react-toastify";
import {
  deleteCoordinate,
  updateCoordinate,
} from "../../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import { useDispatch, useSelector } from "react-redux";
import Draggable from "react-draggable";
import { Resizable } from "re-resizable";
import {
  handleShapeToggleButton,
  selectVariable,
  updateBoxSize,
} from "../../../store/reducers/pdfeditor/toolsModificationSlice";
import { Box } from "@mui/material";
import ToolBarShape from "./ToolbarShape";
import { ImportantDevices } from "@mui/icons-material";
import { debounce, throttle } from "lodash";

function ShapeBox({
  enableDargging,
  coordinate,
  scale,
  dimensions,
  isSelected,
  onSelect,
  setSelectedBoxId,
}) {
  const nodeRef = useRef(null);
  const dispatch = useDispatch();
  const { currBoxSize, shapeToggleButton } = useSelector(
    (state) => state.toolsModification
  );
  // console.log("shpae toggle button in shapebox", shapeToggleButton);
  console.log("coordinate in shapebox is", coordinate);
  const [boxSize, setBoxSize] = useState({
    width: coordinate.width || currBoxSize?.width,
    height: coordinate.height || currBoxSize?.height,
  });
  const [position, setPosition] = useState({
    x: 0,
    y: 0,
    prex: parseInt(coordinate["x-coordinate"]) * scale,
    prey: parseInt(coordinate["y-coordinate"]) * scale,
  });

  const handleSelectBox = (coordinates) => {
    dispatch(
      selectVariable({
        variable: coordinates.id,
        fontSize: coordinates.fontSize,
        width: coordinate.width,
        height: coordinate.height,
        boldVal: coordinates.boldVal,
        italicVal: coordinates.italicVal,
        data_type: coordinate.data_type,
        variableName: coordinates.value,
        fontFamily: coordinates.fontFamily,
        fontSpace: coordinates.fontSpace,
        thickness: coordinate.thickness,
        rotation: coordinate.rotation,
        color: coordinate.color,
        shape: coordinate.shape,
      })
    );
    dispatch(
      updateCoordinate({
        id: coordinate.id,
        newValue: {
          thickness: coordinate.thickness,
          rotation: coordinate.rotation,
          color: coordinate.color,
          shape: coordinate.shape,
        },
      })
    );
  };
  useEffect(() => {
    setPosition({
      x: 0,
      y: 0,
      prex: parseInt(coordinate["x-coordinate"]) * scale,
      prey: parseInt(coordinate["y-coordinate"]) * scale,
    });
  }, [coordinate, scale]);

  // const handleDrag = (e, data) => {
  //   setPosition((prevPosition) => {
  //     const newPosition = {
  //       ...prevPosition,
  //       x: data.x,
  //       y: data.y,
  //     };

  //     return newPosition;
  //   });
  // };

  // Throttled handleDrag function using lodash's throttle
  const throttledHandleDrag = useCallback(
    throttle((data) => {
      setPosition((prevPosition) => ({
        ...prevPosition,
        x: data.x,
        y: data.y,
      }));
    }, 70), // 100ms delay for smooth performance
    []
  );

  const handleDrag = (e, data) => {
    throttledHandleDrag(data); // Use throttled version of handleDrag
  };

  useEffect(() => {
    if (isSelected) {
      handleSelectBox(coordinate);
    }
  }, [isSelected]);

  const widthPdf = dimensions?.width;
  const heightPdf = dimensions?.height;

  const handleStop = (e, data) => {
    console.log("handlestop called");
    const updatedCoordinates = {
      "x-coordinate": (position.prex + data.x) / scale,
      "y-coordinate": (position.prey + data.y) / scale,
    };
    const { width, height } = boxSize || {};
    const xCoord = updatedCoordinates["x-coordinate"] * scale;
    const yCoord = updatedCoordinates["y-coordinate"] * scale;

    // console.log("else xcord and ycord are", xCoord, yCoord, width, height);
    if (
      widthPdf < xCoord + width ||
      widthPdf < 0 ||
      xCoord < 0 ||
      yCoord < 0 ||
      heightPdf < yCoord + height
    ) {
      toast.error(
        "Coordinate should stay within the PDF previewer area when dragging."
      );
      // Reset position to prevent moving out of bounds
      setPosition({
        x: 0,
        y: 0,
        prex: parseInt(coordinate["x-coordinate"]) * scale,
        prey: parseInt(coordinate["y-coordinate"]) * scale,
      });
    } else {
      dispatch(
        updateCoordinate({ id: coordinate.id, newValue: updatedCoordinates })
      );
    }
    onSelect(); // Ensure box is selected on drag stop
  };

  const handleResizeStop = (e, direction, ref, d) => {
    // let resizeWidth = shapeToggleButton ==="line" ? 0 : d.width;
    console.log("coordinate shape is: ", coordinate?.shape);
    let resizeHeight = coordinate?.shape === "line" ? 0 :  boxSize.height + d.height;

    // setIsDragging(false)
    setBoxSize({
      width: boxSize.width + d.width,
      height: resizeHeight,
      // width: boxSize.width + d.width,
      // height: boxSize.height + d.height,
    });
    dispatch(
      updateBoxSize({
        width: boxSize.width + d.width,
        height: resizeHeight,
        // width: boxSize.width + d.width,
        // height: boxSize.height + d.height,
      })
    );
    dispatch(
      updateCoordinate({
        id: coordinate.id,
        newValue: {
          ...coordinate,
          width: boxSize.width + d.width,
          height: resizeHeight,
          // width: boxSize.width + d.width,
          // height: boxSize.height + d.height,
        },
      })
    );
  };
  const iconStyle = {
    right: -9,
    zIndex: 3,
    backgroundColor: "transparent",
    padding: "0px",
    width: "14px",
    height: "14px",
    cursor: "pointer",
    position: "absolute",
    left: `${position.prex - 7 + position.x}px`,
    top: `${position.prey - 8 + position.y}px`,
  };
  return (
    <>
      {isSelected && (
        <ToolBarShape
          style={{ ...iconStyle, zIndex: 12 }}
          settedFontSize={coordinate?.fontSize}
          settedFontSpace={coordinate?.fontSpace}
          settedBoxHeight={coordinate?.height}
          settedBoxWidth={coordinate?.width}
          position={position}
          coordinate={coordinate}
          // handleImageUpload={handleImageUpload}
          // imageUrl={imageUrl}

          setSelectedBoxId={setSelectedBoxId}
        />
      )}

      {!isSelected ? (
        <Draggable
          nodeRef={nodeRef}
          position={position}
          // onStart={(e) => {
          //   e.preventDefault(); // Prevent default behavior if needed
          // }}
          onStop={handleStop}
          style={{
            height: `${coordinate.height} !important`,
            width: `${coordinate.width} !important`,
            zIndex: 2,
          }}
          onClick={() => onSelect()}
          onDrag={handleDrag}
        >
          <Box
            ref={nodeRef}
            sx={{
              position: "absolute",
              left: `${position.prex}px`,
              top: `${position.prey}px`,
              cursor: "move",
              height: coordinate.height,
              width: coordinate.width,
              textAlign: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              transition: "all 0.1s ease-out",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              zIndex: 2,
              // border: shapeToggleButton==="line" ? `${coordinate?.thickness}px 0 solid #000`:`${coordinate?.thickness}px solid #000`,
              borderTop:
                coordinate?.shape === "line"
                  ? `${coordinate?.thickness}px solid ${coordinate?.color}`
                  : `${coordinate?.thickness}px solid ${coordinate?.color}`,
              borderBottom:
                coordinate?.shape === "line"
                  ? `0`
                  : `${coordinate?.thickness}px solid ${coordinate?.color}`,
              borderLeft:
                coordinate?.shape === "line"
                  ? "0"
                  : `${coordinate?.thickness}px solid ${coordinate?.color}`,
              borderRight:
                coordinate?.shape === "line"
                  ? "0"
                  : `${coordinate?.thickness}px solid ${coordinate?.color}`,
              borderRadius: coordinate?.radius,
              boxSizing: "border-box",
              // transform: `rotate(${coordinate.rotation}deg) !important`,
              transform: `translate(${position.x}px, ${position.y}px) rotate(${coordinate.rotation}deg) !important`,
              // filter:'blur(4px)',
            }}
          ></Box>
        </Draggable>
      ) : (
        <Resizable
          axis={coordinate?.shape === "line" ? "x" : "both"}
          style={{
            position: "absolute",
            left: `${position.prex}px`,
            top: `${position.prey}px`,
            height: coordinate.height,
            width: coordinate.width,
            overflow: "hidden",
            transition: "all 0.1s ease-out",
            fontSize: "15px",
            background: "none",
            outline: "none",
            border: "1px dashed #000000",
            borderRadius: "3px",
            // backgroundImage: imageUrl ? `url(${imageUrl})` : "none",
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: 2,
            transform: `rotate(${coordinate.rotation}deg)`,
          }}
          //  onMouseEnter={() => {
          //    if (clickFlag) {
          //      return;
          //    }
          //    handleSelectBox(coordinate);
          //    setFlag(true);
          //  }}
          //  onMouseLeave={() => {
          //    if (clickFlag) {
          //      return;
          //    }
          //    setFlag(false);
          //  }}
          //  onClick={() => setClickFlag((prev) => !prev)}
          onMouseEnter={() => onSelect()}
          onMouseLeave={() => onSelect()}
          onClick={() => onSelect()}
          onResizeStart={() => {}}
          onResizeStop={handleResizeStop}
        >
          <Box
            sx={{
              height: coordinate.height,
              width: coordinate.width,
              fontWeight: `${coordinate?.boldVal ? "bold" : "normal"}`,
              fontStyle: `${coordinate?.italicVal ? "italic" : "normal"}`,
              position: "relative",
              resize: "none",
              overflow: "hidden",
              borderTop:
                coordinate?.shape === "line"
                  ? `${coordinate?.thickness}px solid ${coordinate?.color}`
                  : `${coordinate?.thickness}px solid ${coordinate?.color}`,
              borderBottom:
                coordinate?.shape === "line"
                  ? `0`
                  : // ? `${coordinate?.thickness}px solid ${coordinate?.color}`
                    `${coordinate?.thickness}px solid ${coordinate?.color}`,
              borderLeft:
                coordinate?.shape === "line"
                  ? "0"
                  : `${coordinate?.thickness}px solid ${coordinate?.color}`,
              borderRight:
                coordinate?.shape === "line"
                  ? "0"
                  : `${coordinate?.thickness}px solid ${coordinate?.color}`,
              borderRadius: coordinate?.radius,
              // transform: `rotate(${coordinate.rotation}deg)`,
              margin: "0 !important",
              padding: "0 !important",
              boxSizing: "border-box",
            }}
          ></Box>
        </Resizable>
      )}
    </>
  );
}

export default ShapeBox;
